<template>
  <v-card
    elevation="2"
    outlined
  >
    <v-card-title class="d-flex align-content-end flex-wrap align-items-end">
      <v-container fluid>
        <v-row>
          <v-select
            v-model="query.rank"
            :items="rank"
            label="ระดับสมาชิก"
            outlined
            dense
            class="my-2"
          />
          <v-spacer />
          <v-text-field
            outlined
            dense
            autocomplete="off"
            v-model="query.text"
            hide-details
            label="ค้นหาชื่อ"
            class="my-2"
            @input="query.text = $event"
          />
          <v-spacer />
          <v-text-field
            outlined
            dense
            autocomplete="off"
            v-model="query.bank"
            hide-details
            label="ค้นหาชื่อ-เลขบัญชี"
            class="my-2"
            @input="query.bank = $event"
          />
          <v-spacer />
          <v-text-field
            outlined
            dense
            autocomplete="off"
            v-model="query.ip"
            hide-details
            label="ค้นหาip"
            class="my-2"
            @input="query.ip = $event"
          />
          <v-spacer />
          <div class="my-2">
            <v-btn
              color="primary"
              @click="fetchData"
            >
              <v-icon left>
                mdi-check
              </v-icon>
              ค้นหา
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="ml-2"
              @click="resetFilter"
            >
              ล้าง
            </v-btn>
          </div>
        </v-row>
      </v-container>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <div>
        <v-btn
          color="red"
          class="text-white"
        >
          สมาชิกใหม่
          <v-chip
            right
            color="white"
            x-small
            class="ml-2"
            @click="fetchData"
          >
            {{ newMemberCount }}
          </v-chip>
        </v-btn>
      </div>
      <div style="overflow-x: scroll">
        <v-data-table
          :footer-props="footer"
          :headers="headers"
          :items="items"
          :loading="loading"
          :multi-sort="false"
          :options.sync="options"
          :search.sync="search"
          :server-items-length="totalItems"
          class="elevation-0"
        >
          <!-- item -->

          <template #item.name="{ item }">
            <p class="ma-0 text-left">
              {{ item.id }}#{{ item.name }}
            </p>
            <p class="text-left text-muted">
              {{ item.mobile }}
            </p>
          </template>
          <template #item.level="{ item }">
            <v-chip
              v-if="item.level === 'user'"
              class="ma-2"
              color="secondary"
              outlined
              small
            >
              user
            </v-chip>
            <v-chip
              v-else-if="item.level === 'superuser'"
              class="ma-2"
              color="red"
              outlined
              small
            >
              superuser
            </v-chip>
          </template>
          <template #item.rank="{ item }">
            <v-chip
              v-if="item.rank === 'user'"
              class="ma-2"
              color="primary"
              small
            >
              user
            </v-chip>
            <v-chip
              v-else-if="item.rank === 'gold'"
              class="ma-2"
              color="yellow"
              small
            >
              gold
            </v-chip>
            <v-chip
              v-else-if="item.rank === 'platinum'"
              class="ma-2"
              color="warning"
              small
            >
              platinum
            </v-chip>
            <v-chip
              v-else-if="item.rank === 'diamond'"
              class="ma-2"
              color="success"
              small
            >
              diamond
            </v-chip>
            <v-chip
              v-else-if="item.rank === 'superdiamond'"
              class="ma-2"
              color="success"
              small
            >
              superdiamond
            </v-chip>
          </template>
          <template #item.banks[0]="{ item }">
            <v-row>
              <v-col
                :sm="5"
                :md="3"
              >
                <v-img
                  class="ma-0"
                  :max-width="50"
                  :src="item.banks[0].logo_url"
                />
              </v-col>
              <v-col
                :sm="7"
                :md="9"
              >
                <p class="ma-0 text-left text-no-wrap">
                  {{ item.banks[0].account_name }}
                </p>
                <p class="pa-0 text-left text-muted">
                  {{ item.banks[0].account_number }}
                </p>
              </v-col>
            </v-row>
          </template>
          <template #item.ip_address="{ item }">
            <p
              class="mb-0 d-inline-block text-wrap"
              style="max-width: 100px"
            >
              {{ item.ip_address }}
            </p>
          </template>
          <template #item.created_at="{ item }">
            <p
              class="ma-0 d-inline-block text-wrap"
              style="max-width: 100px"
            >
              {{ $moment(item.created_at).format("YYYY-MM-DD HH:mm:ss") }}
            </p>
            <p>
              <v-chip
                pill
                class="pa-1 m-0 ml-2"
                x-small
              >
                {{
                  $moment(item.created_at).fromNow()
                }}
              </v-chip>
            </p>
          </template>

          <template #item.remark="{ item }">
            <div>
              <span v-if="item.count_remark > 0">
                <v-btn
                  icon
                  @click="displayRemark(item)"
                >
                  <v-icon color="yellow darken-2">mdi-alert</v-icon>
                </v-btn>
              </span>
            </div>
            <div>
              <span v-if="item.count_warning > 0">
                <v-btn
                  icon
                  @click="displayWarning(item)"
                >
                  <v-icon color="orange darken-2">mdi-radioactive</v-icon></v-btn>
              </span>
            </div>
          </template>

          <template #item.detail="{ item }">
            <v-row no-gutters>
              <v-col align-self="center">
                <div>
                  <span justify="center">
                    <v-btn
                      icon
                      @click="displayDialog(item)"
                    >
                      <v-icon color="green darken-2">mdi-menu</v-icon>
                    </v-btn>
                  </span>
                </div>
              </v-col>
              <v-col align-self="center">
                <div v-if="role == 'admin'">
                  <span v-if="item.status != 'suspended'">
                    <v-switch
                      inset
                      input-value="true"
                      @change="changeStatusMember(item.id)"
                    />
                  </span>
                  <span v-else>
                    <v-switch
                      inset
                      @change="changeStatusMember(item.id)"
                    /></span>
                </div>
                <div v-else>
                  <span v-if="item.status != 'suspended'">
                    <v-btn
                      icon
                      @click="suspendMember(item.id)"
                    >
                      <v-icon color="red darken-2">mdi-delete</v-icon>
                    </v-btn>
                  </span>
                </div>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </div>
    </v-card-text>

    <div>
      <v-dialog
        v-if="selectedItem"
        v-model="selectedItem"
        width="600"
        max-width="100vw"
        hide-overlay
      >
        <v-card>
          <v-toolbar
            dark
            color="primary"
          >
            <v-card-title>
              <span class="text-body-1 text-uppercase text-monospace">{{
                selectedItem.name
              }}</span>
            </v-card-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="selectedItem = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-container>
            <v-row>
              <div class="text-center">
                <v-chip
                  class="ma-2"
                  label
                  color="primary"
                >
                  credit:{{
                    Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(amount_credit)
                  }}
                </v-chip>
                <v-chip
                  class="ma-2"
                  label
                  color="secondary"
                >
                  aff:{{
                    Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(amount_aff)
                  }}
                </v-chip>
                <v-chip
                  class="ma-2"
                  label
                  color="warning"
                >
                  vip:{{
                    Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(amount_vip)
                  }}
                </v-chip>
                <v-chip
                  class="ma-2"
                  label
                  color="info"
                >
                  point:{{
                    Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(amount_point)
                  }}
                </v-chip>
              </div>
            </v-row>
            <v-list flat>
              <v-list-item
                v-for="item in menuLinks"
                :key="item.title"
                link
                @click="eventClickMenu(item.action)"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider />

            <v-list flat>
              <v-list-item
                v-for="item in menuManages"
                :key="item.title"
                link
                @click="eventClickMenu(item.action)"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-container>

          <v-divider />
          <v-card-actions>
            <v-btn
              color="blue darken-1"
              text
              outlined
              @click="selectedItem = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-if="depositItem"
        v-model="depositItem"
        width="500"
        max-width="100vw"
        persistent
      >
        <v-card>
          <v-toolbar
            dark
            color="red darken-1"
          >
            <v-card-title>
              <span class="text-body-1">ฝากตรงยูสเซอร์ {{ depositItem.name }}</span>
            </v-card-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="resetDeposit()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-container>
            <v-form ref="depositForm">
              <v-col lg="12">
                <label
                  for="directdebitAmount"
                  class="my-2"
                >ใส่จำนวนเงิน</label>
              </v-col>
              <v-col lg="12">
                <div class="form-group">
                  <v-text-field
                    v-model="directdebitAmount"
                    pattern="\d"
                    required
                    name="directdebitAmount"
                    class="form-control text-center text-lg"
                    maxlength="7"
                    min="1"
                    solo
                    @keypress="validateNumber($event)"
                  />
                </div>
              </v-col>
              <v-col lg="12">
                <label
                  for="directdebitRemark"
                  class="my-2"
                >หมายเหตุ</label>
              </v-col>
              <v-col lg="12">
                <div class="form-group">
                  <v-text-field
                    v-model="directdebitRemark"
                    name="directdebitRemark"
                    class="form-control text-center text-lg"
                    solo
                  />
                </div>
              </v-col>
              <v-col lg="12">
                <v-btn
                  color="success"
                  class="mr-4"
                  @click="directDebit(depositItem.id)"
                >
                  บันทึก
                </v-btn>
              </v-col>
            </v-form>
          </v-container>

          <v-divider />
          <v-card-actions>
            <v-btn
              color="red darken-1"
              text
              @click="resetDeposit()"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="remarkItem"
        width="500"
        max-width="100vw"
        persistent
      >
        <v-card>
          <v-toolbar
            dark
            color="red darken-1"
          >
            <v-card-title>
              <span class="text-body-1">หมายเหตุ</span>
            </v-card-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="resetRemark()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-list
            subheader
            two-line
          >
            <v-subheader inset>
              รายการหมายเหตุ
            </v-subheader>

            <v-list-item
              v-for="item in remarkList"
              :key="item.id"
            >
              <v-list-item-avatar>
                <v-icon color="yellow darken-2">
                  mdi-alert
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="item.message" />
                <v-list-item-subtitle>
                  {{ $moment(item.created_at).format("YYYY-MM-DD HH:mm:ss") }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn
                  icon
                  @click="deleteRemark(item.id)"
                >
                  <v-icon color="red datrken-1">
                    mdi-delete
                  </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-divider />

          <v-container>
            <v-form ref="remarkForm">
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="remarkDetail"
                    solo
                    name="remarkDetail"
                    label="ใส่หมายเหตุ"
                  />
                </v-col>
              </v-row>

              <v-btn
                color="success"
                class="mr-4"
                @click="addRemark()"
              >
                บันทึก
              </v-btn>
            </v-form>
          </v-container>

          <v-divider />
          <v-card-actions>
            <v-btn
              color="red darken-1"
              text
              outlined
              @click="resetRemark()"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="warningItem"
        width="500"
        max-width="100vw"
        persistent
      >
        <v-card>
          <v-toolbar
            dark
            color="red darken-1"
          >
            <v-card-title>
              <span class="text-body-1">แจ้งเตือน</span>
            </v-card-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                icon
                @click="resetWarning()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-list
            subheader
            two-line
          >
            <v-subheader inset>
              รายการแจ้งเตือน
            </v-subheader>

            <v-list-item
              v-for="item in warningList"
              :key="item.id"
            >
              <v-list-item-avatar>
                <v-icon color="orange darken-2">
                  mdi-radioactive
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="item.message" />
                <v-list-item-subtitle>
                  {{ $moment(item.created_at).format("YYYY-MM-DD HH:mm:ss") }}
                  <span>{{ warningTypeName[item.type] }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn
                  icon
                  @click="deleteWarning(item.id)"
                >
                  <v-icon color="red datrken-1">
                    mdi-delete
                  </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-divider />

          <v-container>
            <v-form ref="waringForm">
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="warningSelect"
                    :items="warningType"
                    item-text="state"
                    item-value="type"
                    label="สถานะใบเตือน"
                    solo
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="warningDetail"
                    solo
                    name="remarkDetail"
                    label="แจ้งเตือน"
                  />
                </v-col>
              </v-row>

              <v-btn
                color="success"
                class="mr-4"
                @click="addWarning()"
              >
                บันทึก
              </v-btn>
            </v-form>
          </v-container>

          <v-divider />
          <v-card-actions>
            <v-btn
              color="red darken-1"
              text
              outlined
              @click="resetWarning()"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-if="preload"
        v-model="preload"
        persistent
        width="500"
        max-width="100vw"
      >
        <v-card class="pa-md-10 mx-lg-auto">
          <v-container class="text-center">
            <v-progress-circular
              :size="100"
              :width="10"
              indeterminate
              color="primary"
            />
          </v-container>
        </v-card>
      </v-dialog>
    </div>
  </v-card>
</template>
<script>
import axios from 'axios';
// import { EventBus } from "../../event-bus";
import { Echo } from '../../plugins/pusher';

export default {
  name: 'MemberTable',
  props: {
    role: { type: String, default: '' },
  },
  data() {
    return {
      footer: {
        itemsPerPageOptions: [10, 25, 50, 100],
      },
      loading: true,
      search: '',
      headers: [
        {
          text: 'ชื่อผู้ใช้',
          value: 'name',
          align: 'center',
          cellClass: 'text-monospace',
          sortable: false,
        },
        {
          text: 'ประเภท',
          value: 'level',
          align: 'center',
          justify: 'center',
          cellClass: 'text-monospace',
        },
        {
          text: 'ระดับ',
          value: 'rank',
          align: 'center',
          justify: 'center',
          cellClass: 'text-monospace',
        },
        {
          text: 'บัญชี',
          value: 'banks[0]',
          align: 'center',
          justify: 'center',
          cellClass: 'text-monospace',
        },
        {
          text: 'ip-address',
          value: 'ip_address',
          align: 'center',
          sortable: false,
          searchable: false,
        },
        { text: 'วันที่สมัคร', value: 'created_at', align: 'center' },
        {
          text: 'หมายเหตุ',
          value: 'remark',
          align: 'center',
          sortable: false,
          searchable: false,
        },
        {
          text: 'จัดการ',
          value: 'detail',
          align: 'center',
          sortable: false,
          searchable: false,
        },
      ],
      items: [],
      totalItems: 0,
      sortBy: null,
      sortDirection: null,
      options: {},
      query: {
        text: '',
        ip: '',
        bank: '',
      },
      newMemberCount: 0,
      selectedItem: false,
      depositItem: false,
      rank: ['all', 'user', 'gold', 'platinum', 'diamond', 'superdiamond'],
      menuLinks: [
        {
          icon: 'mdi-wallet',
          title: ' ฝากตรงยูสเซอร์',
          action: 'deposit',
        },
        {
          icon: 'mdi-account-details',
          title: 'ข้อมูลสมาชิก',
          action: 'member_info',
        },
        {
          icon: 'mdi-account-cog',
          title: ' แก้ไขสมาชิก',
          action: 'edit_member',
        },
        {
          icon: 'mdi-view-list',
          title: ' รายงานโพย',
          action: 'report_ticket',
        },
        {
          icon: 'mdi-cash',
          title: ' รายงานเครดิต',
          action: 'report_credit',
        },
        {
          icon: 'mdi-finance',
          title: ' รายงานAff',
          action: 'report_aff',
        },
        {
          icon: 'mdi-chart-timeline-variant-shimmer',
          title: ' รายงานPoint',
          action: 'report_point',
        },
      ],
      menuManages: [
        {
          icon: 'mdi-alert',
          title: 'หมายเหตุ',
          action: 'remark',
        },
        {
          icon: 'mdi-radioactive',
          title: 'ใบเตือน',
          action: 'warning',
        },
      ],
      remarkItem: false,
      remarkList: null,
      remarkDetail: null,

      warningItem: false,
      warningList: null,
      warningDetail: null,
      warningSelect: null,
      warningType: [
        { state: 'ปกติ', type: 'warning' },
        { state: 'ใบเหลือง', type: 'warning-caution' },
        { state: 'ใบแดง', type: 'warning-suspended' },
      ],
      warningTypeName: {
        warning: 'ปกติ',
        'warning-caution': 'ใบเหลือง',
        'warning-suspended': 'ใบแดง',
      },
      directdebitAmount: 0,
      directdebitRemark: '',
      amount_credit: 0,
      amount_aff: 0,
      amount_vip: 0,
      amount_point: 0,
      preload: false,
      userId: null,
    };
  },

  computed: {},

  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },

  mounted() {
    Echo.join(`agent.${window.appState.user.agent_id}`).listen(
      'new-user',
      this.recieveNewMember,
    );
    // EventBus.$on("new-user", this.recieveNewMember);
  },

  methods: {
    fetchData() {
      this.loading = true;
      axios
        .get('/api/member', {
          params: {
            page: this.options.page,
            sortBy: this.options.sortBy[0],
            sortDirection:
              this.options.sortDesc.length > 0
                ? this.options.sortDesc[0]
                  ? 'ASC'
                  : 'DESC'
                : null,
            pageSize: this.options.itemsPerPage,
            type: this.query.type === 'all' ? null : this.query.type,
            rank: this.query.rank === 'all' ? null : this.query.rank,
            text:
              this.query.text.trim().length === 0
                ? null
                : this.query.text.trim(),
            bank:
              this.query.bank.trim().length === 0
                ? null
                : this.query.bank.trim(),
            ip: this.query.ip.trim().length === 0 ? null : this.query.ip.trim(),
          },
        })
        .then((response) => {
          this.items = response.data.data;
          this.totalItems = response.data.total;
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.loading = false;
        });
    },
    getUserInfo(id) {
      axios
        .get(`/api/member/${id}`)
        .then((response) => {
          this.amount_credit = response.data.credit_amount;
          this.amount_aff = response.data.aff_amount;
          this.amount_vip = response.data.vip_amount;
          this.amount_point = response.data.point_amount;
        })
        .catch((e) => console.error(e))
        .finally(() => {});
    },
    resetFilter() {
      this.query = {
        text: '',
        ip: '',
        bank: '',
      };
      this.rank = [
        'all',
        'user',
        'gold',
        'platinum',
        'diamond',
        'superdiamond',
      ];
      this.fetchData();
    },
    recieveNewMember() {
      this.newMemberCount++;
    },
    suspendMember(id) {
      const textConfirm = confirm('คุณต้องการลบรายชื่อนี้ใช่หรือไม่');
      if (textConfirm) {
        axios
          .delete(`/api/member/${id}`)
          .then((response) => {
            this.fetchData();
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.selectedItem = false;
          });
      }
    },
    changeStatusMember(id) {
      axios
        .post(`/api/member/updateStatus/${id}`)
        .then((response) => {
          this.fetchData();
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.selectedItem = false;
        });
    },
    displayDialog(item) {
      this.selectedItem = item;
      this.getUserInfo(item.id);
    },

    eventClickMenu(action) {
      switch (action) {
        case 'deposit':
          this.displayDirectDebit(this.selectedItem);
          break;
        case 'member_info':
          window.open(
            `/management/member/getinfo/${this.selectedItem.id}`,
            '_blank',
          );
          break;
        case 'edit_member':
          window.open(`member/${this.selectedItem.id}`, '_blank');
          break;
        case 'report_ticket':
          window.open(
            `/management/member/ticket/${this.selectedItem.id}`,
            '_blank',
          );
          break;
        case 'report_credit':
          window.open(
            `/management/member/credit/${this.selectedItem.id}`,
            '_blank',
          );
          break;
        case 'report_aff':
          window.open(
            `/management/member/aff/${this.selectedItem.id}`,
            '_blank',
          );
          break;
        case 'report_point':
          window.open(
            `/management/member/point/${this.selectedItem.id}`,
            '_blank',
          );
          break;
        case 'remark':
          this.displayRemark(this.selectedItem);
          break;
        case 'warning':
          this.displayWarning(this.selectedItem);
          break;
      }
    },

    displayDirectDebit(item) {
      this.userId = item.id;
      this.depositItem = item;
      this.selectedItem = false;
    },
    displayRemark(item) {
      this.userId = item.id;
      this.getRemark(item.id);
      this.remarkItem = true;
      this.selectedItem = false;
    },
    displayWarning(item) {
      this.userId = item.id;
      this.getWarning(item.id);
      this.warningItem = true;
      this.selectedItem = false;
    },
    validateNumber(evt) {
      evt = evt || window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31
        && (charCode < 48 || charCode > 57)
        && charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    directDebit(userId) {
      const link = '/api/directdebit/request';
      var userId = userId;
      const amount = this.directdebitAmount;
      const remark = this.directdebitRemark;
      const data = {
        receiver_id: userId,
        amount,
        remark,
      };
      this.preload = true;
      this.depositItem = false;
      axios
        .post(link, data)
        .then((response) => {
          if (response.status == 200) {
            Vue.$toast.open({
              message: 'เติมเครดิตเรียบร้อย',
              type: 'success',
              duration: 3000,
              position: 'top-right',
            });
          }
        })
        .finally(() => {
          this.preload = false;
          this.selectedItem = false;
        })
        .catch((error) => {
          if (error.response.status == 406) {
            Vue.$toast.open({
              message: 'เครดิตไม่พอ',
              type: 'error',
              duration: 3000,
              position: 'top-right',
            });
          } else {
            Vue.$toast.open({
              message: 'พบข้อผิดพลาด กรุณาลองใหม่',
              type: 'error',
              duration: 3000,
              position: 'top-right',
            });
          }
        });
    },

    getRemark(id) {
      const link = `/management/member/remark/${id}`;
      const self = this;
      this.preload = true;
      axios
        .get(link)
        .then((response) => {
          self.remarkList = response.data;
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.preload = false;
        });
    },

    addRemark() {
      const link = '/management/member/remark';
      const self = this;
      if (this.remarkDetail) {
        const data = {
          receiver_id: self.userId,
          message: self.remarkDetail,
        };
        this.preload = true;
        axios
          .post(link, data)
          .then((response) => {
            self.getRemark(self.userId);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.preload = false;
          });
      } else {
        alert('กรุณาระบุหมายเหตุ');
      }
    },

    deleteRemark(id) {
      const link = `/management/member/remark/${id}`;
      const confirmText = confirm('ต้องการลบรายการนี้ใช่หรือไม่');
      const self = this;
      this.preload = true;
      if (confirmText) {
        axios
          .delete(link)
          .then((response) => {
            self.getRemark(self.userId);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.preload = false;
          });
      }
    },
    getWarning(id) {
      const link = `/management/member/warning/${id}`;
      const self = this;
      this.preload = true;
      axios
        .get(link)
        .then((response) => {
          self.warningList = response.data;
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.preload = false;
        });
    },

    addWarning() {
      const link = '/management/member/warning';
      const self = this;
      if (self.warningDetail && self.warningSelect) {
        const data = {
          receiver_id: self.userId,
          message: self.warningDetail,
          warning: self.warningSelect,
        };
        this.preload = true;
        axios
          .post(link, data)
          .then((response) => {
            self.getWarning(self.userId);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.preload = false;
          });
      } else {
        alert('กรุณาระบุหมายเหตุการแจ้งเตือน');
      }
    },

    deleteWarning(id) {
      const link = `/management/member/remark/${id}`;
      const confirmText = confirm('ต้องการลบรายการนี้ใช่หรือไม่');
      const self = this;
      if (confirmText) {
        this.preload = true;
        axios
          .delete(link)
          .then((response) => {
            self.getWarning(self.userId);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.preload = false;
          });
      }
    },
    resetDeposit() {
      this.fetchData();
      this.depositItem = false;
      this.$refs.depositForm.reset();
    },
    resetRemark() {
      this.fetchData();
      this.remarkItem = false;
      this.$refs.remarkForm.reset();
    },
    resetWarning() {
      this.fetchData();
      this.warningItem = false;
      this.$refs.waringForm.reset();
    },
  },
};
</script>
